import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/faq/Manage -my-account-q2-01.png")